export default {"src":"/_next/static/media/search.645e1d28.svg","height":40,"width":40};